import { render, staticRenderFns } from "./ReviewPage9.vue?vue&type=template&id=a66dbefe&"
import script from "./ReviewPage9.vue?vue&type=script&lang=js&"
export * from "./ReviewPage9.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage9.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports